// Libraries
import { DefaultTheme, createGlobalStyle } from 'styled-components'

export const theme: DefaultTheme = {
  colors: {
    blue800: '#F7FBFD',
    blueDarkest: '#0092C7',
    blueDark: '#05B5F5',
    blueDefault: '#3DC0F0',
    blueLight: '#74CCEC',
    blueLighter: '#A6DAED',
    blueDarkerDarkest: '#000000',
    blueDarkerDark: '#060713',
    blueDarkerDefault: '#171B37',
    blueDarkerLight: '#2C3154',
    blueDarkerLighter: '#474B6C',
    gradients01: 'linear-gradient(180deg, #171B37 0%, #626BB5 100%)',
    gradients02:
      'linear-gradient(180deg, rgba(68, 78, 156, 0.5) 0%, rgba(68, 78, 156, 0) 100%)',
    gradients03:
      'linear-gradient(180deg, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0.1) 100%)',
    gradients04:
      'linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(209, 212, 233, 0.5) 31.77%, rgba(151, 157, 206, 0.5) 64.58%, rgba(98, 107, 181, 0.5) 96.35%)',
    gradients01150:
      'linear-gradient(180deg, rgba(98, 107, 181, 0.15) 0%, rgba(23, 27, 55, 0.15) 96.35%)',
    gradients01300:
      'linear-gradient(180deg, rgba(23, 27, 55, 0.3) 0%, rgba(98, 107, 181, 0.3) 100%)',
    gradients03350:
      'linear-gradient(180deg, rgba(61, 192, 240, 0.35) 0%, rgba(23, 27, 55, 0.35) 100%)',
    gradients07350:
      'linear-gradient(180deg, rgba(96, 187, 238, 0.35) 0%, rgba(27, 0, 84, 0.35) 100%)',
    gray01: '#212529',
    gray02: '#343A40',
    gray03: '#495057',
    gray04: '#868E96',
    gray05: '#ADB5BD',
    gray06: '#CED4DA',
    gray07: '#DEE2E6',
    gray08: '#E9ECEF',
    gray09: '#F1F3F5',
    gray10: '#F8F9FA',
    purpleDarkest: '#192161',
    purpleDark: '#2C3682',
    purpleDefault: '#444E9C',
    purpleLight: '#686FAC',
    purpleLighter: '#9295B5',
    red: '#EB5757',
    white00: '#FFFFFF',
    white01: '#F5F5F5',
    white02: '#FBFBFB',
    white03: '#FFFDFD',
  },
  fontFamily: {
    lato: 'Lato, sans-serif',
    inter: 'Inter, sans-serif',
  },
  fontSize: {
    h1: '56px',
    h2: '48px',
    h3: '40px',
    h4: '32px',
    h5: '24px',
    h6: '20px',
    p: '18px',
    small: '15px',
    xsmall: '14px',
    xxsmall: '12px',
  },
  fontWeight: {
    black: 900,
    extraBold: 800,
    bold: 700,
    semiBold: 600,
    medium: 500,
    regular: 400,
    light: 300,
  },
  breakpoints: {
    desktopMin: 1280,
    largeMin: 1330,
    tabletMin: 750,
    mobileMax: 412,
  },
}

export const GlobalStyle = createGlobalStyle`

  * {
    box-sizing: border-box;
  }

  html {
    line-height: 1.15; 
    -webkit-text-size-adjust: 100%; 
  }

  body {
    margin: 0;
  }

  main {
    display: block;
  }

  h1 {
    font-size: 2em;
    margin: 0.67em 0;
  }

  hr {
    box-sizing: content-box;
    height: 0;
    overflow: visible;
  }

  pre {
    font-family: monospace, monospace;
    font-size: 1em;
  }

  a {
    background-color: transparent;
  }

  abbr[title] {
    border-bottom: none;
    text-decoration: underline;
    text-decoration: underline dotted;
  }

  b,
  strong {
    font-weight: bolder;
  }

  code,
  kbd,
  samp {
    font-family: monospace, monospace;
    font-size: 1em;
  }

  small {
    font-size: 80%;
  }

  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }

  sub {
    bottom: -0.25em;
  }

  sup {
    top: -0.5em;
  }

  img {
    border-style: none;
  }

  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: inherit;
    font-size: 100%;
    line-height: 1.15; 
    margin: 0; 
  }

  button,
  input { 
    overflow: visible;
  }

  button,
  select { 
    text-transform: none;
  }

  button,
  [type="button"],
  [type="reset"],
  [type="submit"] {
    -webkit-appearance: button;
  }

  button::-moz-focus-inner,
  [type="button"]::-moz-focus-inner,
  [type="reset"]::-moz-focus-inner,
  [type="submit"]::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }

  button:-moz-focusring,
  [type="button"]:-moz-focusring,
  [type="reset"]:-moz-focusring,
  [type="submit"]:-moz-focusring {
    outline: 1px dotted ButtonText;
  }

  fieldset {
    padding: 0.35em 0.75em 0.625em;
  }

  legend {
    box-sizing: border-box;
    color: inherit;
    display: table;
    max-width: 100%;
    padding: 0;
    white-space: normal;
  }

  progress {
    vertical-align: baseline;
  }

  textarea {
    overflow: auto;
  }

  [type="checkbox"],
  [type="radio"] {
    box-sizing: border-box;
    padding: 0;
  }

  [type="number"]::-webkit-inner-spin-button,
  [type="number"]::-webkit-outer-spin-button {
    height: auto;
  }

  [type="search"] {
    -webkit-appearance: textfield;
    outline-offset: -2px;
  }

  [type="search"]::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  ::-webkit-file-upload-button {
    -webkit-appearance: button; 
    font: inherit; 
  }

  details {
    display: block;
  }

  summary {
    display: list-item;
  }

  template {
    display: none;
  }

  [hidden] {
    display: none;
  }
`
